module.exports = __webpack_public_path__ + "static/media/IconUserInactive.ed2fdf87.svg";